module.exports = __webpack_public_path__ + "static/img/stay-option-icon-airpurigier.898ad304.svg";